/**
 * PricingBlock — the "Vehicle Pricing" section. Extracted from Landing.jsx
 * so both the homepage and the standalone /pricing page can render it
 * identically without duplication.
 */
import PricingCard from "@/components/PricingCard";

export default function PricingBlock({ tiers = [] }) {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-24 md:py-32 px-6 md:px-10 max-w-[100rem] mx-auto"
    >
      <div className="mb-16 md:mb-20 grid md:grid-cols-[1fr_auto] gap-8 items-end">
        <div>
          <div className="bracket mb-4 flex items-center gap-3">
            <span className="num-solid text-[10px]">/01</span>
            STANDARD TIERS
          </div>
          <h2
            className="font-display text-5xl md:text-6xl lg:text-7xl font-extrabold uppercase tracking-[-0.03em] leading-[0.9]"
          >
            VEHICLE<br/>
            <span className="text-[var(--accent)] text-glow">PRICING.</span>
          </h2>
          <p className="mt-6 text-[var(--muted)] max-w-xl text-base md:text-lg leading-relaxed">
            Per-vehicle pricing across four release tiers. Tebex items ship escrowed; commission tiers go through Discord.
          </p>
        </div>
        <div className="hidden md:block num-solid text-[140px] lg:text-[180px] opacity-20">
          04
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        {tiers.map((t, i) => (
          <PricingCard key={t.id} tier={t} index={i} />
        ))}
      </div>
    </section>
  );
}
